module.exports = __webpack_public_path__ + "static/img/7.d5b5eff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/zh/7.png
// module id = Fgko
// module chunks = 0